export enum StaftPunkFeatureFlags {
    HubSpotEmailBouncedToNovaProfile = 'hubSpot-email-bounced-to-nova-profile',
    EnableEmergencyContact = 'nova-emergency-contact',
    EnableEmailInvalidationR1 = 'email-invalidation-r1',
    EnableCandidatePronouns = 'enable-candidate-pronouns',
    EnableUndoDoNotProspectNova = 'enable-undo-do-not-prospect-nova',
    EnableAlternateNamesNewFlow = 'enable-alternate-names-new-flow-in-nova',
    EnablePendingLicenseNova = 'pending-license-nova'
}
